<template>
  <li class="m-vow">
    …<slot></slot>.
  </li>
</template>

<script>
export default {
  name: 'vow'
}
</script>

<style lang="scss">
.m-vow {
  list-style-type: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Vow.vue